import { render, staticRenderFns } from "./TrasladarRegistros.vue?vue&type=template&id=5585f01b&"
import script from "./TrasladarRegistros.vue?vue&type=script&lang=js&"
export * from "./TrasladarRegistros.vue?vue&type=script&lang=js&"
import style0 from "./TrasladarRegistros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports